/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, interval } from 'rxjs';
import { AuthService, Logger, LogService } from '@epg/angular-base-lib';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false
})
export class LoginComponent implements OnInit, OnDestroy {
  timerSubscription: Subscription = new Subscription();

  private log: Logger;
  constructor(
    private router: Router,
    private auth: AuthService,
    private logService: LogService,
    private route: ActivatedRoute
  ) {
    this.log = logService.getLogger(this);
  }
  ngOnDestroy(): void {
    this.timerSubscription.unsubscribe();
  }

  ngOnInit(): void {
    let alreadyNavigated = false;
    this.timerSubscription = interval(1000).subscribe((val) => {
      this.log.debug('inside login timer');
      if (this.auth.isAuthenticated && !alreadyNavigated) {
        alreadyNavigated = true;
        const loginGuardRequestedFrom = sessionStorage.getItem('loginGuardRequestedFrom');
        sessionStorage.removeItem('loginGuardRequestedFrom');
        loginGuardRequestedFrom
          ? this.router.navigateByUrl(loginGuardRequestedFrom)
          : this.router.navigate(['home']);
      }
    });
  }
}
